import {
  Component,
  HostListener,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { PlatformService } from 'src/app/services/platform.service';
import {
  AbstractScanner,
  APP_SCANNER,
} from 'src/app/services/scanner/scanner.types';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-scanner',
  templateUrl: './scanner.component.html',
  styleUrls: ['./scanner.component.scss'],
})
export class ScannerComponent implements OnInit {
  @ViewChild('zxingScanner', { static: false })
  scanner!: ZXingScannerComponent;

  constructor(
    @Inject(APP_SCANNER) public readonly scannerService: AbstractScanner,
    public readonly platformService: PlatformService
  ) {}

  ngOnInit() {
    return;
  }

  ngOnDestory() {
    this.scannerService.stopScanner().subscribe();
  }

  ngAfterViewInit(): void {
    this.scannerService.runScanner().subscribe();
  }

  @HostListener('window:blur', ['$event'])
  onTabFocusOut(event: Event): void {
    environment.production && this.scannerService.stopScanner().subscribe();
  }

  @HostListener('window:focus', ['$event'])
  onTabFocusIn(event: Event): void {
    if (!this.scannerService.isRan) {
      environment.production && this.scannerService.runScanner().subscribe();
    }
  }
}
